<template>
    <b-container>
        <b-card title="Card Title" no-body>
            <b-card-header header-tag="nav">
                <b-nav card-header tabs>
                    <b-nav-item active-class="active" :to="{ name: 'content-list'}">List</b-nav-item>
                    <b-nav-item active-class="active" :to="{ name: 'content-page'}">Pages</b-nav-item>
                    <b-nav-item active-class="active" :to="{ name: 'content-template'}">Templates</b-nav-item>
                </b-nav>
            </b-card-header>

            <b-card-body class="text-center">
                <router-view></router-view>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
    // @ is an alias to /src
    import {mapActions, mapState} from "vuex";
    import {config} from "@shared/_services/config";
    import TemplateApi from "@shared/_api/cms/template";

    export default {
        name: 'cmsContent',
        data() {
            return {
                contentTableList: ['id', 'label'],
                editFields: {},
                editSchema: {},
                baseUrl: config.baseUrl + config.resourceUrl,
                templateList: [],
                selectedTemplate: null
            }
        },
        created() {
            this.fetchContentList();
            this.fetchPageList();
            this.loadTemplateList();
        },
        methods: {
            ...mapActions('content', ['fetchContentList', 'fetchPageList', 'setEditEntry', 'updateContent', 'insertContent', 'deleteContent']),
            save() {
                if (this.editFields.id) {
                    this.updateContent({content: this.editFields}).then(() => {
                        this.fetchContentList();
                        this.fetchPageList();
                    });
                } else {
                    this.templateFields.template = this.templateList.find(template => {
                        return template.id === this.selectedTemplate;
                    });
                    this.insertContent({content: this.editFields}).then(() => {
                        this.fetchContentList();
                        this.fetchPageList();
                    });
                }
            },
            setNew(fields, schema, template, listId) {
                this.editSchema = Object.assign({}, schema);
                let contentData = {
                    template: template,
                    contentDataSet: {},
                    listId: listId
                };

                this.selectedTemplate = template.id;

                fields.forEach(field => {
                    contentData.contentDataSet[field] = {
                        value: '',
                        templateField: schema.find(obj => {
                            return obj.name === field
                        })
                    };
                });


                this.editFields = contentData;
            },
            setEdit(values, schema) {
                this.editFields = JSON.parse(JSON.stringify(values));
                this.editSchema = Object.assign({}, schema);
                this.selectedTemplate = this.editFields.template.id;
            },
            deleteEntry(id) {
                this.deleteContent({contentId: id}).then(() => {
                    this.fetchContentList();
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
            loadTemplateList: function () {
                //this.busy = true;
                TemplateApi.get().then((templateList) => {
                    this.templateList = templateList;
                }).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                   // this.busy = false;
                })
            },
        },
        computed: {
            ...mapState('content', ['contentList', 'pageList']),
            templateOptions() {
                return this.templateList.map(template => {
                    return {
                        value: template.id,
                        text: template.label
                    }
                })
            },
        }
    }
</script>